import React, { Component } from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import Layout from "../components/layout"
 
import SEO from "../components/seo"
import "../css/post.css"
import {
  FacebookShareCount,
  PinterestShareCount,
  VKShareCount,
  OKShareCount,
  RedditShareCount,
  TumblrShareCount,
  FacebookShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  RedditShareButton,
  EmailShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  WeiboShareButton,
  PocketShareButton,
  InstapaperShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  MailruIcon,
  EmailIcon,
  LivejournalIcon,
  ViberIcon,
  WorkplaceIcon,
  LineIcon,
  PocketIcon,
  InstapaperIcon,
  WeiboIcon,
} from "react-share";

function stripMarkdown (string) {
  try {
    let tmp = document.createElement("div")
    tmp.innerHTML = string

    return tmp.textContent
  } catch {
    return string
  }
}

class Post extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }


  componentDidMount(){

  }

  readingTime = ev => {
    const wordsPerMinute = 200; // Average case.
    let result;

    let textLength = ev.split(" ").length; // Split by words
    if(textLength > 0){
      let value = Math.ceil(textLength / wordsPerMinute);
      result = `~${value} min read`;
    }

  return result
  };

  render() {

    const shareUrl = this.props.location.href;
    const title = this.props.data.wordpressPost.title;
    const post = this.props.data.wordpressPost
    const featured_img = this.props.pageContext.featured_img

    return (
      <Layout> <SEO />
        <div className="mainContainer deep-blue">
          <div className="centeredContainer blogPost">
            <div ref={this.myRef} dangerouslySetInnerHTML={{__html:this.readingTime(post.content)} }></div>
            <h1 style={{flexBasis: "100%"}} dangerouslySetInnerHTML={{__html: stripMarkdown(title)}}></h1>
            <div className="post-featured-img" style={{backgroundImage: `url(${featured_img})`}}/>
          </div>
        </div>
        <div className="mainContainer" style={{paddingTop: 150}}>
          <div className="centeredContainer post-content wrap" style={{padding: "0 50px"}}>
            <div className="post-social">
              <FacebookShareButton
                url={shareUrl}
                quote={title}
                className="Demo__some-network__share-button"
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
                  <TwitterShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button">
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
              <RedditShareButton
                url={shareUrl}
                title={title}
                windowWidth={660}
                windowHeight={460}
                className="Demo__some-network__share-button"
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <TumblrShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
              >
                <TumblrIcon size={32} round />
              </TumblrShareButton>
              <EmailShareButton
                url={shareUrl}
                subject={title}
                body="body"
                className="Demo__some-network__share-button"
              >
                <EmailIcon size={32} round />
              </EmailShareButton>
            </div>
            <div dangerouslySetInnerHTML={{__html:post.content }}/>
          </div>
        </div>
      </Layout>
    )
  }
}

Post.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
}

export default Post

export const postQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      title
      content
    }
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`
